import React, { useContext } from "react";
import { I18nContext } from "../../contexts/I18nContext";
import { TranslationKey } from "../../contexts/I18nContext/translationKeys";
import SanitizedReactHtmlParser from "../../utils/SanitizedReactHtmlParser/SanitizedReactHtmlParser";
import { escapeHtml } from "../../utils/escapeHtml";

interface TranslateProps {
  translationKey: TranslationKey;
  replacements?: Record<string, string | number>;
}

export function Translate({
  translationKey,
  replacements,
}: TranslateProps): JSX.Element {
  const { getTranslation } = useContext(I18nContext);

  return <>{getTranslation(translationKey, replacements)}</>;
}

export const TranslateHtml = ({
  translationKey,
  replacements,
}: {
  translationKey: TranslationKey;
  replacements?: Record<string, string | number>;
}) => {
  const { getTranslation } = React.useContext(I18nContext);

  // The translation itself is authored markup and is meant to render as HTML;
  // the replacement values are not. Escaping them here — before they are
  // interpolated into the template — keeps them confined to text nodes.
  // Sanitizing afterwards cannot help: by then the value is indistinguishable
  // from the template's own markup.
  const escapedReplacements = replacements
    ? Object.fromEntries(
        Object.entries(replacements).map(([key, value]) => [
          key,
          escapeHtml(value.toString()),
        ]),
      )
    : undefined;

  return (
    <SanitizedReactHtmlParser
      content={getTranslation(translationKey, escapedReplacements)}
    />
  );
};
